import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks, siteTagline } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const overHero = isHome && !scrolled && !menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        overHero
          ? "bg-transparent border-b border-white/10"
          : "bg-background-50/95 backdrop-blur-md border-b border-background-200"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          <div className="flex items-center gap-4 lg:gap-8">
            <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="爆料直播 首页">
              <span
                className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading text-lg font-bold shrink-0 ${
                  overHero ? "bg-background-50 text-primary-700" : "bg-primary-500 text-background-50"
                }`}
              >
                爆
              </span>
              <span className="flex flex-col leading-none">
                <span
                  className={`font-heading text-lg md:text-xl font-bold tracking-wide ${
                    overHero ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  爆料直播
                </span>
                <span
                  className={`hidden sm:block text-[10px] tracking-[0.2em] mt-0.5 ${
                    overHero ? "text-background-200" : "text-foreground-500"
                  }`}
                >
                  {siteTagline}
                </span>
              </span>
            </Link>

            <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
              {navLinks.map((item) => {
                const active =
                  item.path === "/"
                    ? location.pathname === "/"
                    : location.pathname.startsWith(item.path);
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`px-3.5 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                      active
                        ? overHero
                          ? "text-background-50 bg-white/15"
                          : "text-primary-700 bg-primary-50"
                        : overHero
                          ? "text-background-100 hover:text-background-50 hover:bg-white/10"
                          : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                    }`}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/report"
              className={`hidden md:inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                overHero
                  ? "bg-background-50 text-primary-700 hover:bg-background-100"
                  : "bg-primary-500 text-background-50 hover:bg-primary-600"
              }`}
            >
              <i className="ri-live-line" aria-hidden="true"></i>
              立即举报
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
                overHero ? "text-background-50 hover:bg-white/10" : "text-foreground-800 hover:bg-background-100"
              }`}
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 md:px-8 py-4 flex flex-col gap-1" aria-label="移动导航">
            {navLinks.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="px-3 py-3 rounded-md text-base font-medium text-foreground-800 hover:bg-background-100 hover:text-foreground-950 transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/report"
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              <i className="ri-live-line" aria-hidden="true"></i>
              立即举报
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}